// frontend/src/utils/recordingLock.js
//
// En patientmötesinspelning åt gången per webbläsare: ett Web Lock hålls av den
// flik som spelar in, från start till avslut (eller tills fliken stängs, då
// släpper webbläsaren låset själv). Andra flikar/fönster får "upptaget".
// Desktop-appen och andra webbläsare delar inte låset — där skyddar servern (409).

const LOCK_NAME = 'aion-notes-patientinspelning';

let releaseFn = null;

const locksSupported = () =>
  typeof navigator !== 'undefined' && !!navigator.locks?.request;

// Försök ta låset. Returnerar 'acquired', 'busy' (annan flik spelar in) eller
// 'unsupported' (webbläsaren saknar Web Locks — inspelning tillåts ändå).
export function acquireRecordingLock() {
  if (releaseFn) return Promise.resolve('acquired');
  if (!locksSupported()) return Promise.resolve('unsupported');

  return new Promise((resolve) => {
    navigator.locks
      .request(LOCK_NAME, { ifAvailable: true }, (lock) => {
        if (!lock) {
          resolve('busy');
          return undefined;
        }
        // Håll låset tills releaseRecordingLock() anropas.
        return new Promise((done) => {
          releaseFn = () => {
            releaseFn = null;
            done();
          };
          resolve('acquired');
        });
      })
      .catch(() => resolve('unsupported'));
  });
}

export function releaseRecordingLock() {
  if (releaseFn) releaseFn();
}

// Spelar en ANNAN flik/fönster i den här webbläsaren in just nu?
export async function isRecordingElsewhere() {
  if (releaseFn || !navigator.locks?.query) return false;
  try {
    const state = await navigator.locks.query();
    return state.held.some((l) => l.name === LOCK_NAME);
  } catch (_) {
    return false;
  }
}
